import { StockDialogsContainer } from "../StockDialogsContainer";

interface DialogManagerProps {
  isAddProductDialogOpen: boolean;
  setIsAddProductDialogOpen: (open: boolean) => void;
  isDeleteProductDialogOpen: boolean;
  setIsDeleteProductDialogOpen: (open: boolean) => void;
  isCartDialogOpen: boolean;
  setIsCartDialogOpen: (open: boolean) => void;
  isRestockDialogOpen: boolean;
  setIsRestockDialogOpen: (open: boolean) => void;
  isReturnDialogOpen: boolean;
  setIsReturnDialogOpen: (open: boolean) => void;
  isLossDialogOpen: boolean;
  setIsLossDialogOpen: (open: boolean) => void;
  selectedItem: any;
  stockItems: any[];
  handleAddProduct: (data: any) => void;
  handleDeleteProduct: (id: string) => void;
  refetch: () => void;
}

export const DialogManager = (props: DialogManagerProps) => {
  return <StockDialogsContainer {...props} />;
};